export default {
  all: '',
  products: 'products',
  services: 'services',
};
